// extracted by mini-css-extract-plugin
export default {"cls1":"he1uezfKOTRYO4ahhyEf","cls2":"TgrpjPPnJ_3JlReNsgZq he1uezfKOTRYO4ahhyEf"};